import { createPortal } from 'react-dom';
import { AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui';

interface UnlinkClubModalProps {
	isOpen: boolean;
	onClose: () => void;
	onConfirm: () => void;
	clubName: string;
	isUnlinking?: boolean;
}

export const UnlinkClubModal = ({
	isOpen,
	onClose,
	onConfirm,
	clubName,
	isUnlinking = false,
}: UnlinkClubModalProps) => {
	if (!isOpen) return null;

	return createPortal(
		<div className="fixed inset-0 z-[9999] flex items-center justify-center p-4">
			<div
				className="absolute inset-0 bg-stone-900/60 backdrop-blur-[2px]"
				onClick={onClose}
			/>
			<div className="animate-in zoom-in-95 relative w-full max-w-[400px] rounded-[2rem] bg-white p-8 text-center shadow-2xl duration-200">
				<div className="mb-4 flex justify-center text-rose-500">
					<div className="rounded-full bg-rose-50 p-4">
						<AlertTriangle size={32} />
					</div>
				</div>
				<h3 className="mb-2 text-xl font-black text-stone-900">
					Desvincular clube
				</h3>
				<p
					className="mb-8 text-sm font-medium leading-relaxed text-stone-500"
					dangerouslySetInnerHTML={{
						__html: `Tem certeza que deseja desvincular o clube <strong>${clubName}</strong> desta empresa?`,
					}}
				/>
				<div className="flex flex-col gap-3">
					<Button
						text={
							isUnlinking
								? 'Desvinculando...'
								: 'Confirmar desvinculação'
						}
						disabled={isUnlinking}
						className="w-full justify-center rounded-full border-none bg-rose-600 py-3 font-bold text-white shadow-md hover:bg-rose-700 disabled:opacity-70"
						onClick={onConfirm}
					/>
					<button
						onClick={onClose}
						disabled={isUnlinking}
						className="text-sm font-bold text-stone-400 transition-colors hover:text-stone-600 disabled:opacity-50"
					>
						Cancelar
					</button>
				</div>
			</div>
		</div>,
		document.body,
	);
};
